import { Breadcrumb, Col, Row, Space, Table } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { MultiFetcher } from '../../utilities/MultiFetcher';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { ParseMlText } from '../../utilities/MlTextHelper';
import { AddButton, DeleteButton, EditButton } from '../_common/CustomButtons';
import { PartCategory } from '../../../models/PartCategory';
import { PartCategoriesDropDown } from '../_common/PartCategoriesDropDown';
import { Part } from '../../../models/Part';
import _ from 'lodash';

interface State {
    parts: Part[];
    categories: PartCategory[];
    selectedCategoryId?: string;
}

export const PartList = withAuthenticationRequired(() => { 
    
    const [state, setState] = useState<State>({
        parts: [],
        categories: [],
        selectedCategoryId: undefined
      });

    const {fetchMultiple: fetchParts, deleteSingle: deletePart, isLoading: isLoadingParts} = MultiFetcher('part');   
    const {fetchMultiple: fetchCategories, isLoading: isLoadingCategories} = MultiFetcher('partCategory');   

    const fetchAllCategories = useCallback(async() => {
        const allCategories = await fetchCategories({disableCache: true}) as PartCategory[];
        const categories = _.sortBy(allCategories.filter(cat => allCategories.find(subcat => subcat.parentId === cat.id) == null), 'parentName', 'name');
        setState(prevState => ({ ...prevState, categories }));
        //console.log(`categories: ${JSON.stringify(categories)}`)
    }, [fetchCategories]);

    const fetchAllParts = useCallback(async () => {
        const queryParams = state.selectedCategoryId ? `categoryId=${state.selectedCategoryId}` : undefined;
        const parts = await fetchParts({queryParams, disableCache: true});
        setState(prevState => ({ ...prevState, parts }));
        //console.log(`data: ${JSON.stringify(Parts)}`); 
    }, [fetchParts, state.selectedCategoryId]);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchAllCategories();
    }, [fetchAllCategories]);

    useEffect(() => {
        fetchAllParts();
    }, [fetchAllParts]);

    const deleteItem = async (id: string) => {
        deletePart(id).then(async () => await fetchAllParts());
    }

    const onCategoryChange = (value: string) => {
        setState(prevState => ({ ...prevState, selectedCategoryId: value }));
    }

    return (
        <React.Fragment>
            
            <Breadcrumb style={{ margin: '16px 0', paddingLeft: '50px' }}>
                <Breadcrumb.Item>Admin</Breadcrumb.Item>
                <Breadcrumb.Item>Parts</Breadcrumb.Item>
            </Breadcrumb>

            <div style={{ width: '80%', margin: 'auto', marginBottom: '25px'}}>

                <div style={{ width: '100%', textAlign: 'center', marginBottom: '20px'}} className={'ant-card-head-title'}>Parts</div>

                <Row>
                    <Col  
                        xs={{ span: 24 }}
                        sm={{ span: 20 }}
                        md={{ span: 16 }}
                        lg={{ span: 12 }}
                        xl={{ span: 8 }}>
                            <PartCategoriesDropDown categories={state.categories} isLoading={isLoadingCategories} required={false} onChange={onCategoryChange} />
                    </Col>
                </Row>

                <Table 
                    loading={isLoadingParts}
                    rowKey={'id'}
                    columns={[
                        // {
                        //     title: 'Id',
                        //     dataIndex: 'id',
                        //     key: 'id',
                        // },
                        
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (name) => <span>{ParseMlText(name)['en']}</span>
                        },
                        {
                            title: 'ArticleNumber',
                            dataIndex: 'articleNumber',
                            key: 'articleNumber',
                            render: (articleNumber) => <span>{articleNumber}</span>
                        },
                        {
                            title: 'Visible',
                            dataIndex: 'visible',
                            key: 'visible',
                            render: (value) => <span>{value === true ? 'Yes' : 'No'}</span>
                        },
                        {
                            title: '# Photos',
                            dataIndex: 'imageIds',
                            key: 'imageIds',
                            render: (imageIds: string[]) => <span>{imageIds?.length ?? 0}</span>
                        },
                        {
                            title: 'Category',
                            dataIndex: 'categoryName',
                            key: 'category',
                            //render: (name, row) => <span>{ParseMlText(name)['en']}</span>
                            render: (name, row) => <span>{row.parentCategoryName ? `${ParseMlText(row.parentCategoryName)['en']} / ${ParseMlText(name)['en']}` : ParseMlText(name)['en']}</span>,
                            className: state.selectedCategoryId ? 'hide' : 'show'

                        },
                        {
                            key: 'actions',
                            align: 'right',
                            render: (record: any) => 
                                <Space>
                                    <EditButton url={`/Admin/Part/${record.id}`} />
                                    <DeleteButton id={record.id} onDelete={deleteItem} />
                                </Space>
                        }
                            
                    ]} 
                    dataSource={state.parts} />
                <Space>
                    <AddButton url='/Admin/Part/' />
                </Space>

            </div>

        </React.Fragment>
    );
})